export default __webpack_public_path__ + "static/media/star-badge.45b7e88c.svg";